const lightTheme = {
  name: 'light',
  isDark: false
}

export type LightThemeType = typeof lightTheme
export { lightTheme }
